import axios from 'Src/helpers/api/axiosInstance';
import { AppUser } from 'Src/views/App/App';

export interface StudentTeamSport {
  id: string;
  name: string;
  assignment?: { positionName?: string; isCaptain?: boolean; isViceCaptain?: boolean; sub?: boolean } | null;
}

export interface StudentTeam {
  id: string;
  name: string;
  description?: string;
  season: string;
  gender?: string;
  ages: number[];
  schoolId: string;
  sports: StudentTeamSport[];
  isCaptain?: boolean;
  isViceCaptain?: boolean;
  isSubstitute?: boolean;
  positionName?: string;
  roster: Array<{
    id: string;
    userId: string;
    firstName: string;
    lastName: string;
    sportIds?: string[];
    positionsBySport?: Array<{ sportId: string; positionName?: string; isCaptain?: boolean; isViceCaptain?: boolean; sub?: boolean }>;
    positionName?: string;
    isCaptain?: boolean;
    isViceCaptain?: boolean;
    sub?: boolean;
  }>;
}

export interface StudentTeamsOverview {
  total: number;
  season: string;
  teams: StudentTeam[];
}

export function getStudentCurrentTeams(user: AppUser): Promise<StudentTeamsOverview> {
  return axios
    .get<StudentTeamsOverview>(`${window.apiBase}/i/student/teams/current/overview`, {
      headers: { usid: user.roleSessionKey },
      params: { schoolId: user.activeSchoolId }
    })
    .then(response => response.data);
}
